var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckboxDecodo = function SvgIconCheckboxDecodo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    y: 0.5,
    fill: "transparent",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 .5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2zm1.534 8.27 2.333 2.334 6.6-6.6a.655.655 0 0 1 .934 0 .655.655 0 0 1 0 .933l-7.067 7.06c-.26.26-.68.26-.94 0L2.6 9.704a.656.656 0 0 1 0-.933.656.656 0 0 1 .934 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCheckboxDecodo;